import videojs from 'video.js'
import React from 'react'
import ReactDOM from 'react-dom'
import VideoListMenu from '../VideosListMenu'

const vjsComponent = videojs.getComponent('Component')

class VideoList extends vjsComponent {
  constructor (player, options) {
    super(player, options)

    this.options = options

    player.ready(() => {
      this.mountElement()
    })
  }

  mountElement () {
    ReactDOM.render(<VideoListMenu {...this.options} />, this.el())
  }
}

vjsComponent.registerComponent('VideoList', VideoList)

export default VideoList
